import { render, staticRenderFns } from "./workflowForm.vue?vue&type=template&id=82fe8958&scoped=true&"
import script from "./workflowForm.vue?vue&type=script&lang=js&"
export * from "./workflowForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82fe8958",
  null
  
)

export default component.exports